import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';
import PropTypes from 'prop-types';
import Skeleton from '@ynap/skeleton';

const bem = new BEMHelper('AccordionSection');
// TODO: component could be possibly be merged with @yanp/toggle
class AccordionSection extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            contentModifier: null,
            isActive: props.isActive,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let contentModifier = nextProps.isActive ? 'openAnimation' : 'closeAnimation';
        contentModifier = nextProps.isMobileFullScreen ? `${contentModifier}MobileFullScreen` : contentModifier;
        return {
            isActive: nextProps.isActive,
            contentModifier: prevState.isActive != nextProps.isActive && contentModifier,
        };
    }

    render() {
        const {
            heading,
            content,
            uniqueId,
            multiSelect,
            loading,
            onClickOpen,
            onClickClose,
            isActive,
            isDefaultActive,
            className,
            headingClassName,
            sectionId,
            modifier,
            config,
        } = this.props;

        const uniqueIdOpen = `${uniqueId}-open`;
        const uniqueIdClose = `${uniqueId}-close`;
        const radioButtonName = multiSelect ? uniqueId : 'commonName';
        const isfullBleedLayout = config?.head?.pdp?.fullBleedLayout?.enabled;

        return loading ? (
            <div className={bem('skeleton', modifier)}>
                <Skeleton count={2} align="left" className={bem('skeletonWidth')} />
            </div>
        ) : (
            <div className={bem(null, null, className)} id={sectionId}>
                {/* The radio buttons are so that filters works without js */}
                {/* Doesn't work without js for mobile/tablet as displaying filter modal requires js to change classNames. To be addressed in ISP-1831  */}
                <input
                    type="radio"
                    onClick={onClickOpen}
                    name={radioButtonName}
                    className={bem('openRadioButton', isfullBleedLayout ? 'fullBleedLayout' : '')}
                    id={uniqueIdOpen}
                    //onChange method to remove react warning. Checked attribute makes it a controlled component but CSS handles changes for us
                    onChange={() => {}}
                    checked={isActive}
                    defaultChecked={isDefaultActive}
                />
                <input type="radio" onClick={onClickClose} name={radioButtonName} className={bem('closeRadioButton')} id={uniqueIdClose} />
                <label className={bem('heading', null, 'openLabel')} htmlFor={uniqueIdOpen} />
                <label className={bem('heading', [modifier], 'closeLabel')} htmlFor={uniqueIdClose} />
                <div className={bem('heading', ['colour', modifier], headingClassName)}>{heading}</div>
                <span className={bem('arrowIcon', isActive ? [modifier, 'active'] : modifier, 'arrowIcon')} />
                <div className={bem('content', [this.state.contentModifier, modifier], 'content')}>
                    <div className={bem('contentChildWrapper')}>{content}</div>
                </div>
            </div>
        );
    }
}

AccordionSection.propTypes = {
    uniqueId: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    sectionId: PropTypes.string,
    loading: PropTypes.bool,
    onClickClose: PropTypes.func,
    onClickOpen: PropTypes.func,
    isActive: PropTypes.bool,
    isDefaultActive: PropTypes.bool,
    className: PropTypes.string,
    multiSelect: PropTypes.bool,
    modifier: PropTypes.string,
    config: PropTypes.object,
};

export default AccordionSection;
